import type { SetupState } from '../../lib/firstRun'
import { parseGoals, parseProgram } from '../../sync/coaching'
import { useSettings } from '../../sync/useSettings'
import { useSynced } from '../../sync/useSync'

/**
 * What guided setup has to go on (UX spec §3.1): whether the profile, goal, starting point and nutrition program
 * exist, and whether SETTINGS and GOAL have loaded. [loaded] needs both queries to have succeeded, never a cache.
 */
export function useSetupState(): { loaded: boolean; state: SetupState } {
  const { query: settings, profile } = useSettings()
  const goals = useSynced('GOAL', parseGoals)
  const program = useSynced('PROGRAM', parseProgram)
  return {
    loaded: settings.isSuccess && goals.isSuccess,
    state: {
      hasGoal: (goals.data?.length ?? 0) > 0,
      hasProfile: profile !== null,
      hasAlgorithms: (settings.data?.algorithms ?? null) !== null,
      hasProgram: (program.data ?? null) !== null,
    },
  }
}
